import { DragEvent } from "react";

// Clones the dragged card and strips its background/shadow so the native
// browser drag preview only shows the icon and label, not the white card box.
export const createTransparentDragPreview = (event: DragEvent<HTMLDivElement>) => {
  const source = event.currentTarget;
  const preview = source.cloneNode(true) as HTMLDivElement;

  preview.style.position = "fixed";
  preview.style.top = "-9999px";
  preview.style.left = "-9999px";
  preview.style.background = "transparent";
  preview.style.boxShadow = "none";

  document.body.appendChild(preview);
  event.dataTransfer.setDragImage(preview, 0, 0);

  setTimeout(() => {
    document.body.removeChild(preview);
  }, 0);
};
